import { useTranslation } from '@framework/i18n';
import React from 'react';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
const image = { url: require('../../images/MiC_logo_esteso_Negativo.svg') };

const StyledLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  border: none;
  margin: 0;
  padding: 0;
`;

const LogoWrapper = styled.div`
  width: 185px;
  max-width: 100%;
  height: auto;

  ${down('sm')} {
    width: 123px;
  }
`;
export interface IFrontFooterLogoProps {}

/**
 * Logo del footer dell'applicativo.
 */
export function FrontFooterLogo(props: IFrontFooterLogoProps) {
  const { t } = useTranslation();
  return (
    <LogoWrapper>
      <StyledLogoImg
        src={image.url}
        alt={t('mic.front-footer-logo.alt', 'Logo Ministero della Cultura')}
      />
    </LogoWrapper>
  );
}
